import React from 'react';
import { focusChatbot } from '../utils/chatUtils'; // Adjust path as needed

const CTA = () => {
  const handleTellWizbangClick = () => {
    focusChatbot('wizbang-chat-iframe'); // Pass the iframe ID
  };

  return (
    <section id="cta" className="bg-primary dark:bg-blue-800">
      <div className="container flex flex-col items-center px-6 py-12 mx-auto text-center">
        <h2 className="text-3xl font-bold text-white dark:text-white">
          Ready to Automate Your Customer Interactions?
        </h2>

        <p className="mt-4 text-lg text-blue-100 dark:text-blue-200">
          Get started today and see how Wizbang can transform your lead generation and customer support.
        </p>

        <div className="mt-6">
          <button 
             onClick={handleTellWizbangClick} // Updated handler
             type="button"
             className="px-8 py-3 text-sm font-medium tracking-wide text-primary bg-white rounded-lg hover:bg-gray-100 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50 transition-colors duration-300">
            Want a demo? Tell Wizbang! {/* Updated text */}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA; 